<!--
测试用例
<alioss-uploader accept="image/jpeg,image/gif,image/png,image/tiff,image/dng" multiple :id="uploadId" @onError="uploadError" @onSuccess="uploadSuccess" ></alioss-uploader>
-->
<template>
    <!--在此处添加渲染的内容-->
    <div>
        <el-upload
                class = "upload-demo"
                ref = "upload"
                :accept = "upAccept"
                :action = "upAction"
                :multiple = "upMultiple"
                :before-upload = "beforeUpload"
                :http-request = "httpRequest"
                :on-change = "handleChange"
                :on-success = "handleSuccess"
                :auto-upload = "false"
            >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
            <div slot="tip" class="el-upload__tip">上传文件大小不能超过 1G</div>
        </el-upload>
    </div>
</template>

<script type="text/ecmascript-6">
    const SparkMD5 = require('spark-md5');
    const getFileMd5 = function (file, cb) {
        const blobSlice = File.prototype.slice || File.prototype.mozSlice || File.prototype.webkitSlice;
        const fileReader = new FileReader();
        const chunkSize = 2097152;
        const chunks = Math.ceil(file.size / chunkSize);
        let currentChunk = 0;
        const spark = new SparkMD5.ArrayBuffer();
        fileReader.onload = function (e) {
            spark.append(e.target.result)
            currentChunk++
            if (currentChunk < chunks) {
                loadNext()
            } else {
                cb && cb(spark.end());
            }
        }
        fileReader.onerror = function () {
            console.warn('FileReader error.')
        }
        function loadNext () {
            const start = currentChunk * chunkSize
            const end = ((start + chunkSize) >= file.size) ? file.size : start + chunkSize
            // 注意这里的 fileRaw
            fileReader.readAsArrayBuffer(blobSlice.call(file, start, end))
        }
        loadNext()
    };

    export default{
        props: {
            onSuccess: Function,
            onError: Function,
            multiple: Boolean,
            accept: String,
        },
        data() {
            return {
                upAction: '',
                upAccept: 'image/jpeg,image/gif,image/png',
                upMultiple: false,
                fileList: [],
            }
        },
        created() {
            if (this.accept) {
                this.upAccept = this.accept;
            }
            if (this.multiple) {
                this.upMultiple = this.multiple;
            }
        },
        methods: {
            /**
             * 上传到OSS
             * @param opt
             */
            httpRequest(opt) {
                var ossData = new FormData();
                var upfile = this.getFile(opt.file.name);
                ossData.append("name", opt.file.name);
                ossData.append("key", upfile.ossData.key);
                ossData.append("policy", upfile.ossData.policy);
                ossData.append("OSSAccessKeyId", upfile.ossData.OSSAccessKeyId);
                ossData.append("success_action_status", upfile.ossData.success_action_status);
                ossData.append("signature", upfile.ossData.signature);
                ossData.append("callback", upfile.ossData.callback);
                ossData.append("host", upfile.ossData.host);
                ossData.append("x-oss-object-acl", upfile.ossData.x_oss_object_acl);
                ossData.append("file", opt.file, opt.file.name);
                this.$axios.post(upfile.ossData.host, ossData, {
                    headers: {
                        "Content-Type": "multipart/form-data"
                    }
                }).then(res => {
                    if (res.status == 200) {  //上传成功
                        let url = upfile.ossData.host + "/" + upfile.ossData.key;
                        let pic = {
                            name: opt.file.name,
                            md5: upfile.md5,
                            url: url,
                        };
                        this.handleSuccess(pic, "上传成功!");
                    } else {
                        this.handleError(file, '上传失败，请重新尝试!');
                    }
                }).catch(error => {
                    console.log(error);
                });
            },
            /**
             * 上传之前的校验
             * @param file
             * @returns {boolean|boolean}
             */
            beforeUpload(file) {
                this.upAccept = this.upAccept.toLowerCase();
                let isImage = this.upAccept.indexOf(file.type.toLowerCase()) >= 0;
                let isSize = file.size / 1024 / 1024 < 50;
                if (!isImage) {
                    this.handleError(file, '上传文件只能是图片格式['+this.upAccept+']!');
                } else if (!isSize) {
                    this.handleError(file, '上传文件大小不能超过 50MB!');
                }
                return isImage && isSize;
            },
            /**
             * 选择文件后生成MD5并且获取oss直传密钥
             * @param file
             * @param filelist
             */
            handleChange(file, filelist) {
                let _self = this;
                if (file.status == 'ready') {
                    getFileMd5(file.raw, function (md5) {
                        this.$axios.post('/api/alioss/params', {name: file.name, md5: md5})
                            .then(function (response) {
                                if (response.data.code == 200) {
                                    let data = response.data.data;
                                    _self.pushFile({
                                        md5: md5,
                                        name: file.name,
                                        ossData: {
                                            policy : data.policy,
                                            signature : data.signature,
                                            OSSAccessKeyId : data.OSSAccessKeyId,
                                            key : data.key,
                                            host : data.host,
                                            callback : data.callback,
                                            success_action_status : data.success_action_status,
                                            x_oss_object_acl : data.x_oss_object_acl
                                        }
                                    });
                                    _self.uploadSubmit(filelist);
                                }
                            })
                            .catch(function (error) {
                                _self.handleError(file, error);
                            });
                    });
                }
            },
            /**
             * 判断是否提交上传
             * @param filelist
             */
            uploadSubmit(filelist) {
                if (filelist.length == this.fileList.length) {
                    this.$refs.upload.submit();
                    this.$refs.upload.clearFiles();
                    this.fileList = [];
                }
            },
            handleError(file, error) {
                this.$message.error(error);
                // console.log(error);
                this.$emit('onError', file);
            },
            handleSuccess(file, message) {
                this.$message.success(message);
                this.$emit('onSuccess', file);
            },
            pushFile(file) {
                if (!this.getFile(file.name)) {
                    this.fileList.push(file);
                }
            },
            getFile(name) {
                for (var i = 0; i < this.fileList.length; i++) {
                    if (this.fileList[i].name == name) {
                        return this.fileList[i];
                    }
                }
                return false;
            }
        },
    }
</script>

<style scoped>
    /**渲染内容的样式**/

</style>